import * as React from "react";
import './QuickApplicationMobileModal.css';

import {observer} from "mobx-react";
// @ts-ignore
import welcome from "../../../../../assets/images/onBoardingArrows/onboarding-welcome-stars.svg";
import FormButton from "../../../../../components/FormButton/FormButton";

interface IProps {
    onClose: () => void;
    isSBALoan?: boolean
}

@observer
export default class WelcomeModalMobile  extends React.Component<
    IProps
    > {
    public render() {
        const {onClose} = this.props;
        const modalText = this.getTexts();
        return (
            <div className="overlay">
                <img className="img-style" src={welcome}/>
                <div className="text-container">
                    <div className="quick-application-mobile-modal-header">{modalText.header}</div>
                    <div className="quick-application-mobile-modal-sub-header">{modalText.subHeader}</div>
                    <FormButton btnText={"Continue"} classes={"yellow"} click={onClose}/>
                </div>
            </div>
        );
    }

    private getTexts = () => {
        if(this.props.isSBALoan) {
            return {
                header: "Welcome to the Paycheck Protection Program",
                subHeader: "The SBA Paycheck Protection Program is a loan designed to provide a direct incentive for small businesses to keep their workers on the payroll"
            }
        }
        return  {
            header: "Welcome to Salaryo",
            subHeader: "Affordable business loans, up to $250,000. Apply in minutes and get fund the same-day."
        }
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/FormQuickApplication/QuickApplicationMobileModal/WelcomeModalMobile.tsx